import { useAuth } from "@/components/auth/auth-context";
import { PostHogEventName, useTrackEvent } from "@/lib/posthog-events";
import { useCallback } from "react";

export const useMentorPerformanceEvent = () => {
  const { user } = useAuth();
  const { track } = useTrackEvent();

  return {
    track: useCallback(
      (event: PostHogEventName, properties?: Record<string, unknown>) => {
        track(event, {
          ...properties,
          user_id: user?.id,
        });
      },
      [track, user?.id],
    ),
  };
};
